import { enableActivityTracking, newTracker } from '@snowplow/browser-tracker';
import Logger from 'utils/Logger';

let initialized = false;

function init() {
  if (initialized) {
    return;
  }

  Logger.logAnalytics('[Snowplow] init');
  initialized = true;

  newTracker('sp', SNOWPLOW_COLLECTOR_URL, {
    appId: `withlocals-${ENVIRONMENT}`,
    contexts: {
      webPage: true,
      session: true,
    },
  });

  enableActivityTracking({
    minimumVisitLength: 30,
    heartbeatDelay: 10,
  });
}

function ensureInitialized() {
  if (!initialized) {
    init();
  }
}

export default {
  init,
  ensureInitialized,
};
